<template>
  <payment-layout class="payment" :step="2" :bottom-nav-disabled="true">
    <div class="payment-section mt-2" v-if="product.length !== 0">
      <div class="payment__product">
        <div class="payment__product__pic">
          <img onerror="this.style.display= 'none';" :src="product.imagePath" />
        </div>
        <div class="payment__product__info">
          <div class="h4 h4--black">{{ product.title }}</div>
          <div class="type mt-2" v-if="product.deliveryType == 2">
            商品規格：{{ variationName }}
          </div>
        </div>
      </div>
    </div>
    <!--
      付款方式
    -->
    <div class="payment-section payment__method mt-2 pb-2">
      <v-text-field
        clearable
        v-model="promoteCode"
        class="mb-4"
        label="輸入優惠碼"
        :success-messages="couponSuccessMsg"
        :error-messages="couponErrorMsg"
        @change="checkCoupon()"
      />
      <div class="payment-section__head">付款方式</div>
      <v-radio-group
        v-if="payList.length"
        v-model="paymentMethod"
        class="ma-0"
        :rules="[payWayRule]"
      >
        <v-radio
          v-for="(pay, index) in payList"
          :key="index"
          class="ma-0 py-2"
          :label="pay.paymentTypeName"
          :value="pay.paymentType"
          off-icon
        />
      </v-radio-group>
      <div v-if="paymentMethod === 3">
        <v-row>
          <v-col class="py-0" cols="12">
            <v-text-field
              v-model="creditCardNumber"
              type="tel"
              label="卡號"
              maxlength="19"
              @input="getCreditCard"
              :rules="[requiredRule, cardNumberRule]"
              validate-on-blur
            />
          </v-col>
        </v-row>
        <div class="payment-section__head">有效期限MM/YY</div>
        <v-row>
          <v-col class="py-0" :cols="6">
            <v-select
              v-model="month"
              class="v-select--no-label"
              :items="getMonth()"
              label="請選擇"
              :rules="[requiredRule]"
            />
          </v-col>
          <v-col class="py-0" :cols="6">
            <v-select
              v-model="year"
              class="v-select--no-label"
              :items="getYear()"
              label="請選擇"
              :rules="[requiredRule]"
            />
          </v-col>
          <v-col class="py-0" cols="6">
            <v-text-field
              v-model="creditCardCSV"
              type="tel"
              label="卡片驗證碼"
              :maxlength="3"
              :rules="[requiredRule, creditCardCSVRule]"
              validate-on-blur
            />
          </v-col>
        </v-row>
      </div>
      <div v-if="paymentMethod === 5">
        <!-- <div class="payment-section__head">測試什麼link</div>
        <v-row>
          <v-col class="py-0">
            <v-select
              v-model="testLink"
              class="v-select--no-label"
              :items="linkSelect"
              label="請選擇測試LINK"
            />
          </v-col>
        </v-row> -->
      </div>
    </div>
    <!--
      結帳金額
    -->
    <div class="payment-section mt-2 gray-400--text h4">
      <div class="d-flex align-center">
        <span>小計</span>
        <span class="flex-grow-1 text-right h3">
          <!-- price * qty -->
          ${{ subtotal }}
        </span>
      </div>
      <div class="d-flex align-center">
        <span>折扣</span>
        <span class="flex-grow-1 text-right h3">{{ discount }}</span>
      </div>
      <v-divider class="my-2" />
      <div class="d-flex align-center">
        <span>結帳金額</span>
        <span
          class="flex-grow-1 text-right font-weight-black h3 payment__amount"
        >
          ${{ totalAmount }}
        </span>
      </div>

      <v-btn
        :disabled="!validCheckout || couponErrorMsg.length > 0"
        class="v-btn-primary my-2"
        color="primary"
        @click="makeOrder()"
      >
        結帳
      </v-btn>
      <waiting-overlay v-model="submitting"></waiting-overlay>
    </div>
  </payment-layout>
</template>

<script>
import WaitingOverlay from '@/components/shared/WaitingOverlay'

const monthSequence = Array.from({ length: 12 }, (item, index) => {
  const strNum = (index + 1).toString()
  return index + 1 < 10 ? `0${strNum}` : strNum
})
export default {
  name: 'Payment',
  components: {
    WaitingOverlay,
  },
  data() {
    return {
      promoteCode: '',
      couponSuccessMsg: '',
      couponErrorMsg: '',
      letspayOnlyCoupon: false,
      paymentMethod: 0,
      creditCardNumber: '',
      creditCardCSV: '',
      installmentRate: 0,
      month: '',
      year: '',
      product: {},

      id: '',
      variation: '',
      variationName: '',
      qty: 0,
      paymentInfo: {},
      yearSequence: [],
      testLink: -1,
      linkSelect: [
        { text: 'URL', value: 0 },
        { text: 'AND_SCHEME', value: 1 },
        { text: 'UNIVERSAL_LINK', value: 2 },
      ],
      subtotal: 0,
      discount: 0,
      totalAmount: 0,
      makeOrderStatus: '',
      storeGuid: '',
      triMonthInstal: 0,
      sixMonthInstal: 0,

      isOTP: false,
      hppUrl: '',
      orderNo: '',
      submitting: false,
      checkout: false,
      letspayQuery: '',
      paymentType: 0,
      payList: [],
      expired: '',
    }
  },
  mounted() {
    const date = new Date()
    let year = date.getFullYear()

    this.id = this.$route.params.id
    this.variation = this.$route.params.variation
    this.storeGuid = this.$route.params.storeGuid
    this.qty = this.$route.params.qty
    this.paymentInfo = this.$route.params.paymentInfo

    year = year - parseInt(year / 100) * 100
    this.yearSequence = Array.from({ length: 30 }, (item, index) => {
      const strNum = (year + index).toString()
      return year + index < 10 ? `0${strNum}` : strNum
    })

    if (this.id == null) {
      const cartJson = localStorage.getItem('shoppingCart')
      if (cartJson != null) {
        console.log('get data from shopping cart.' + cartJson)
        const cart = JSON.parse(cartJson)
        this.id = cart.id
        if (cart.expired > new Date().getTime()) {
          ;(this.variation = cart.variation),
            (this.qty = cart.qty),
            (this.paymentInfo = cart.paymentInfo),
            (this.storeGuid = cart.storeGuid)
        } else {
          console.log('shopping cart was expired.')
          localStorage.removeItem('shoppingCart')
          this.$bus.$emit('callAllert', {
            messageContent: '閒置過久，請重新購買！',
            callback: () => {
              this.$router.push({ name: 'product', params: { id: this.id } })
            },
          })
        }
      } else {
        // 找不到bid 只好送去首頁
        this.$bus.$emit('callAllert', {
          messageContent: '發生了一點小錯誤！',
          callback: () => {
            if (localStorage.getItem('source') === 'e7g') {
              window.location = process.env.VUE_APP_E7G_HOME
            } else {
              this.$router.replace({ name: 'home' })
            }
          },
        })
      }
    } else {
      // localStorage.setItem(
      //   'shoppingCart',
      //   JSON.stringify({
      //     id: this.id,
      //     qty: this.qty,
      //     variation: this.variation,
      //     expired: expired,
      //     paymentInfo: this.paymentInfo,
      //     storeGuid: this.storeGuid,
      //   })
      // )
    }
    this.getProduct()
    const paymentWay = JSON.parse(window.localStorage.getItem('initial_config'))
    if (!paymentWay) {
      api
        .getInitialConfig()
        .then(res => {
          if (res.code === 1000) {
            window.localStorage.setItem(
              'initial_config',
              JSON.stringify(res.data)
            )
            this.handlePayWay()
          }
        })
        .catch(err => {
          this.$bus.$emit('callAllert', {
            messageContent: '發生了一點錯誤！',
            callback: () => {
              window.history.go(-1)
            },
          })
        })
    } else {
      this.handlePayWay()
    }
  },
  methods: {
    getTotalAmount() {
      if (this.product.isGroupCoupon) {
        this.subtotal = this.product.price
      } else {
        this.subtotal = this.product.price * this.qty
      }
      console.log('subtotal' + this.subtotal)
      this.totalAmount = this.subtotal + this.discount
      this.triMonthInstal = Math.floor(this.totalAmount / 3)
      this.sixMonthInstal = Math.floor(this.totalAmount / 6)
    },
    getMonth() {
      return monthSequence
    },
    getYear() {
      return this.yearSequence
    },
    getCreditCard(event) {
      console.log('keyUp')
      const trimNum = this.creditCardNumber.replace(/\s+/g, '')
      const numArray = trimNum.length ? trimNum.match(/.{1,4}/g) : []
      this.creditCardNumber = numArray.join(' ')
    },
    getVariation() {
      if (this.product.variations.length !== 0) {
        this.variationName = this.product.variations.find(variation => {
          return variation.id == this.variation
        }).name
      }
    },
    getProduct() {
      const self = this
      api
        .getProduct(self.id, true)
        .then(res => {
          self.product = res.data
          self.getTotalAmount()
          self.getVariation()
        })
        .catch(function(err) {
          console.log(err)
        })
    },
    checkCoupon() {
      if (!this.promoteCode) {
        this.couponErrorMsg = ''
        this.couponSuccessMsg = ''
        this.discount = 0
        this.letspayOnlyCoupon = false
        return
      }
      api
        .checkCoupon(this.promoteCode, this.id, this.totalAmount)
        .then(res => {
          if (res.code == 1000) {
            this.couponSuccessMsg = '折抵成功'
            this.couponErrorMsg = ''
            this.discount = res.data.couponAmount * -1
            this.letspayOnlyCoupon = res.data.letsPayOnly
          }
        })
        .catch(err => {
          this.couponSuccessMsg = ''
          this.discount = 0
          this.letspayOnlyCoupon = false
          this.couponErrorMsg = err.message || '未知錯誤'
        })
    },
    cardNumberRule(value) {
      const pattern = /^\d+$/g
      if (
        value.length != 19 ||
        pattern.test(value.replace(/\s+/g, '') == false)
      ) {
        return '請輸入正確格式'
      } else {
        return true
      }
    },
    creditCardCSVRule: function(value) {
      const pattern = /^[0-9]{3}$/
      if (pattern.test(value) == false) {
        return '請輸入正確格式'
      }
      return true
    },
    requiredRule: function(value) {
      if (value == null || value == '') return '必填項目'
      return true
    },
    payWayRule(value) {
      if (value == null || value == '') {
        this.checkout = false
        return '必填項目'
      } else if (value !== 3) {
        this.checkout = true
        return true
      } else {
        this.checkout = false
        return true // prevent warn for radio-group.
      }
    },
    makeOrder() {
      this.submitting = true
      if (this.paymentMethod == 3) {
        this.creditCardNumber = this.creditCardNumber.split(' ').join('')
      }

      if (this.product.deliveryType == 1) {
        // 票券
        this.makeRedemptionOrder()
      } else {
        // 宅配
        this.makeDeliveryOrder()
      }
    },
    goResultPage(err) {
      this.ga()
      if (err) {
        this.$router.push({
          name: 'paymentResult',
          params: { status: this.makeOrderStatus, err: err },
          query: { amount: this.totalAmount, orderNo: this.orderNo },
        })
      } else {
        if (this.paymentMethod === 3) {
          // credit card
          if (this.isOTP && this.hppUrl != '') {
            console.log('3d')
            console.log('hppUrl' + this.hppUrl)
            location.href = this.hppUrl
            return
          } else {
            console.log('non3d')
            this.$router.push({
              name: 'paymentResult',
              params: { status: this.makeOrderStatus },
              query: { amount: this.totalAmount, orderNo: this.orderNo },
            })
          }
        } else if (this.paymentMethod === 5) {
          // pi wallet
          // android_Scheme: "intent://www.piapp.com.tw?type=typec&otp=5711455097&browser=com.android.chrome#Intent;package=tw.com.pchome.android.pi.partner;scheme=pi;end;"
          // expired_At: "2020-07-23 16:47:03"
          this.$router.push({
            name: 'paymentResult',
            params: {
              status: 'wait',
              expired: this.expired,
              deeplink: this.hppUrl,
            },
            query: {
              amount: this.totalAmount,
            },
          })
          return
        } else {
          this.$router.push({
            name: 'paymentResult',
            params: { status: this.makeOrderStatus },
            query: { amount: this.totalAmount, orderNo: this.orderNo },
          })
        }
      }
    },
    makeRedemptionOrder() {
      api
        .makeOrder(
          this.id,
          this.qty,
          this.storeGuid,
          this.paymentMethod,
          this.totalAmount,
          0,
          this.promoteCode,
          this.creditCardNumber,
          this.year,
          this.month,
          this.creditCardCSV,
          this.installmentRate,
          this.paymentInfo.BuyerInfo,
          [],
          {},
          this.paymentInfo.EinvoiceInfo,
          this.paymentInfo.saveReceipt
        )
        .then(res => {
          this.handleOrderResult(res)
        })
        .catch(err => {
          this.makeOrderStatus = 'error'
          this.goResultPage(err)
          this.submitting = false
          console.log(err)
        })
    },
    makeDeliveryOrder() {
      const ItemOption = [
        {
          ProductVariationId: this.variation,
          Quantity: this.qty,
        },
      ]
      api
        .makeOrder(
          this.id,
          this.qty,
          this.storeGuid,
          this.paymentMethod,
          this.totalAmount,
          0,
          this.promoteCode,
          this.creditCardNumber,
          this.year,
          this.month,
          this.creditCardCSV,
          this.installmentRate,
          this.paymentInfo.BuyerInfo,
          ItemOption,
          this.paymentInfo.ShippingInfo,
          this.paymentInfo.EinvoiceInfo,
          this.paymentInfo.saveReceipt
        )
        .then(res => {
          this.handleOrderResult(res)
        })
        .catch(err => {
          this.makeOrderStatus = 'error'
          this.goResultPage(err)
          this.submitting = false
          console.log(err)
        })
    },
    ga() {
      gtag('event', 'purchase', {
        result: this.makeOrderStatus == 'error' ? '訂單失敗' : '訂單成立',
        value: this.totalAmount,
        shipping: 0,
        payment_type: this.paymentMethod == 5 ? 'Pi拍錢包' : '信用卡',
        currency: 'TWD',
        isGroupCoupon: this.product.isGroupCoupon ? '成套票券' : '',
        coupon: this.promoteCode,
        category: this.product.deliveryType == 1 ? '票券' : '宅配',
        variant:
          this.product.deliveryType == 1 ? this.storeGuid : this.variationName,
        items: [
          {
            item_id: this.id,
            item_name: this.product.title,
            // brand: 'Google',
            item_category: this.product.deliveryType == 1 ? '票券' : '宅配',
            item_variant:
              this.product.deliveryType == 1
                ? this.storeGuid
                : this.variationName,
            quantity: this.qty,
            price: this.product.price,
          },
        ],
      })
    },
    getDevice() {
      const u = navigator.userAgent
      const device = {
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1,
        iPad: u.indexOf('iPad') > -1,
        windows: u.indexOf('Windows NT') > -1,
        mac: u.indexOf('Mac') > -1,
      }
      return device
    },
    handleOrderResult(res) {
      if (res.code == 1000) {
        switch (this.paymentMethod) {
          case 1: // ATM
            break
          case 3: // 信用卡
            this.makeOrderStatus = 'success'
            this.isOTP = res.data.isOTP
            this.hppUrl = res.data.hppUrl
            this.orderNo = res.data.OrderNumber
            break
          case 4: // LetsPay
            this.makeOrderStatus = 'letspay'
            this.letspayQuery = res.data.letsPayLink
            break
          case 5: // Pi錢包
            // const device = this.getDevice
            this.expired = res.data.expired_At
            this.isOTP = true
            if (this.testLink > -1) {
              this.hppUrl =
                this.testLink == 0
                  ? res.data.url
                  : this.testLink == 1
                  ? res.data.android_Scheme
                  : res.data.universal_Link
            } else {
              // if (device.android) {
              //   // this.hppUrl = res.data.url
              //   this.hppUrl = res.data.android_scheme
              // } else if (device.iPhone || device.iPad) {
              //   this.hppUrl = res.data.universal_Link
              // } else {
              this.hppUrl = res.data.url // 應該是走url沒錯
              // this.hppUrl = res.data.universal_Link
            }
            break
          default:
            this.makeOrderStatus = 'success'
            this.orderNo = res.data.OrderNumber
            break
        }
        localStorage.removeItem('shoppingCart')
      } else {
        this.makeOrderStatus = 'error'
      }
      this.submitting = false
      this.goResultPage()
    },
    handlePayWay() {
      const paymentWay = JSON.parse(
        window.localStorage.getItem('initial_config')
      ).paymentSetting

      paymentWay.forEach(way => {
        this.payList.push(way)
      })
    },
  },
  computed: {
    validCheckout() {
      if (this.paymentMethod && this.paymentMethod !== 3) {
        return true
      } else if (
        this.paymentMethod == 3 &&
        this.year != null &&
        this.year != '' &&
        this.month != null &&
        this.mouth != '' &&
        this.creditCardCSV != null &&
        this.creditCardCSV != '' &&
        this.creditCardNumber != null &&
        this.creditCardNumber != ''
      ) {
        if (this.creditCardNumber.length != 19) {
          return false
        } else if (this.creditCardCSV.length != 3) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
  },
  watch: {
    discount() {
      this.totalAmount = this.subtotal + this.discount
    },
  },
}
</script>

<style scoped lang="scss">
.payment {
  &__product {
    display: flex;
    &__pic {
      flex: 0 0 auto;
      width: 28%;
      height: 0;
      padding-bottom: 28%;
      border-radius: 16px;
      background: url('~@/assets/img/placholder_512.svg');
      background-size: contain;
      background-repeat: no-repeat;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &__info {
      flex-grow: 1;
      padding-left: 8px;
    }
    .h4--black {
      color: #222222;
    }
    .type {
      color: #9b9b9b;
      font-size: 13px;
    }
  }

  &__method {
    &__description {
      color: white;
      background-color: black;
      padding: 6px 16px;
      font-size: 12px;

      &--tooth {
        position: relative;
        margin-bottom: 8px;

        &:after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 15px;
          border-left: 8px transparent solid;
          border-right: 8px transparent solid;
          border-top: 8px black solid;
        }
      }
    }
  }
  &__amount {
    font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC',
      Arial, Helvetica, sans-serif;
  }
}
</style>
